import * as Sentry from "@sentry/react-native";
import React from "react";
import { useSelector } from "react-redux";
import { View } from "react-native";
import RNRestart from "react-native-restart";
import Config from "react-native-config";
import ErrorViewSvg from "@assets/svg/ErrorView";
import Text from "@components/CustomText";
import Button from "@components/Button";
import analytics from "@services/analytics";

export const FallbackComponent = ({ userPhone }) => {
  const handleAppRestart = () => {
    RNRestart.restart();
  };

  return (
    <View style={{ flex: 1, alignItems: "center", justifyContent: "center" }}>
      <ErrorViewSvg />
      <Text
        variant="caption_3"
        style={{ marginTop: 10, color: "darkgray" }}
      >{`${userPhone || ""} - [${Config.VERSION_NAME}]`}</Text>
      <Text variant="subtitle_16" style={{ marginVertical: 15 }}>
        {"कुछ कारण से ऍप नहीं चल रही है"}
      </Text>
      <Button
        btnText="दुबारा कोशिश करें"
        buttonWidth={200}
        height={55}
        onPress={handleAppRestart}
      />
    </View>
  );
};

const ErrorView = ({ children }) => {
  const userPhone = useSelector(
    (state) => state?.auth?.user?.phone_number || "",
  );

  return (
    <Sentry.ErrorBoundary
      fallback={(fbProps) => (
        <FallbackComponent userPhone={userPhone} {...fbProps} />
      )}
      onError={(error, componentStack, eventId) => {
        analytics.trackEvent("ErrorBoundary Screen", {
          error: error.message,
          componentStack,
          eventId,
        });
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default ErrorView;
